import TtsList from './List'
import TtsFooter from './Footer'
import * as Styled from './styled'
import TtsBulkActions from './BulkActions'
import { ttsSelectors } from 'store/features/tts/selectors'
import { useSelector } from 'react-redux'
import { useDeviceHeight } from 'hooks'

import { useGetTtsMismatchPopupVisible } from './hooks'
import { SMALL_MOBILE_HEIGHT } from './consts'

const TtsContent: React.FC = () => {
  const isSmallMobile = useDeviceHeight(SMALL_MOBILE_HEIGHT)
  const isTtsItemsLoading = useSelector(ttsSelectors.isTtsItemsLoading)

  useGetTtsMismatchPopupVisible()

  return (
    <Styled.TtsTabWrapper $isDisabled={isTtsItemsLoading}>
      {isSmallMobile ? (
        <Styled.SmallMobileOverflowWrapper>
          <TtsBulkActions />
          <TtsList />
        </Styled.SmallMobileOverflowWrapper>
      ) : (
        <>
          <TtsBulkActions />
          <TtsList />
        </>
      )}
      <TtsFooter />
    </Styled.TtsTabWrapper>
  )
}

export default TtsContent
